module.exports = __webpack_public_path__ + "static/media/artwork-size.135bfc8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/artwork-size.png
// module id = 937
// module chunks = 0